<template>
  <el-badge v-if="model.floatEnabled" v-loading="loading" class="support-setting" :style="getStyle" :class="[model.layout, editing && 'editing', $store.getters.isMobile && 'is-mobile']" type="danger" @click.native="handleShowService">
    <img :src="model.logo.backgroundImage" alt="" />
  </el-badge>
</template>

<script>
import {Badge, Message} from 'element-ui'
import { checkUser, loadJsAsync } from '~/utils'
import Bus from '~/site/model/bus'
import { BusEventMap, CustomerSdkEnums, CustomerServiceTypeEnum } from '~/enums/data'

export default {
  components: {
    [Badge.name]: Badge
  },
  props: {
    model: {
      type: Object,
      default: () => {}
    },
    editing: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      aiHelpConfig: {
        app_id: '',
        domain: '',
        entrance_id: ''
      },
      loading: false,
      appHeight: 0
    }
  },
  computed: {
    userId() {
      return this.$store.getters.userId
    },
    getStyle() {
      return {
        '--app-height-px': this.appHeight + 'px'
      }
    },
    aiHelpLang() {
      const local = this.$store.state.locale.locale
      const specialLangMap = {
        'cn': 'zh-CN',
        'tw': 'zh-TW'
      }
      return specialLangMap[local] || local
    },
    type() {
      return this.model.type
    }
  },
  mounted() {
    this.init()
    Bus.$on('reloadGood', (type) => {
      if (type === BusEventMap.Login) {
        this.handleLogin()
        this.checkShow()
      } else if (type === BusEventMap.LoginOut) {
        this.handleLogout()
      }
    })
  },
  methods: {
    getAppHeight() {
      this.appHeight = window.innerHeight
    },
    checkShow() {
      if (this.$store.state.site.nextIsShowCustomerService) {
        this.handleShowService()
        this.$store.commit('site/NEXT_IS_SHOW_CUSTOMER_SERVICE', false)
      }
    },
    async getToolsConfig() {
      this.loading = true
      const configKeys = {
        [CustomerServiceTypeEnum.AIHelp]: 'aiHelpConfig'
      }
      const configKey = configKeys[this.type]
      const params = {
        project_id: this.$store.state.project.projectId,
        third_party: this.type
      }
      const [err, res] = await this.$utils.to(this.$api.store.getToolsConfigInfo(params))
      this.loading = false
      if (!err) {
        const config = res.params
        for (const key in config || {}) {
          this[configKey][key] = config[key]
        }
        config && this.initTools()
      } else {
        Message.error(err)
      }
    },
    initTools() {
      const methods = {
        [CustomerServiceTypeEnum.AIHelp]: this.initAiHelp
      }
      methods[this.type]?.()
    },
    async initAiHelp() {
      const that = this
      if (this.editing) return
      that.loading = true
      await loadJsAsync(CustomerSdkEnums.ai_help)
      const AIHelpSupport = window.AIHelpSupport
      const initConfig = {
        domain: this.aiHelpConfig.domain,
        appId: this.aiHelpConfig.app_id,
        language: this.aiHelpLang
      }
      AIHelpSupport.initialize(initConfig)
      AIHelpSupport.registerAsyncEventListener("initialization", function (jsonData) {
        if (jsonData.isSuccess) {
          that.loading = false
          that.handleLogin()
        } else {
          console.error(jsonData)
        }
      })
      AIHelpSupport.registerAsyncEventListener('userLogin', function (jsonData) {
        console.log(jsonData)
      })
    },
    showAiHelp() {
      window?.AIHelpSupport?.show(this.aiHelpConfig.entrance_id)
    },
    logoutAiHelp() {
      window?.AIHelpSupport?.logout()
    },
    loginAiHelp() {
      const userInfo = this.$store.state.user.siteLoginUserInfo
      const loginConfig = {
        userId: this.userId,
        userConfig: {
          userName: userInfo?.nickname,
          serverId: userInfo?.server_id,
          userTags: [userInfo?.server_id].join(',')
        },
        isEnterpriseAuth: false
      }
      this.userId && window?.AIHelpSupport?.login(loginConfig)
    },
    init() {
      this.getAppHeight()
      if (this.type) {
        this.getToolsConfig()
      }
    },
    handleLogout() {
      const methods = {
        [CustomerServiceTypeEnum.AIHelp]: this.logoutAiHelp
      }
      methods[this.type]?.()
    },
    handleLogin() {
      const methods = {
        [CustomerServiceTypeEnum.AIHelp]: this.loginAiHelp
      }
      methods[this.type]?.()
    },
    async handleShowService() {
      if (this.loading) return
      await checkUser(this, () => {
        this.$store.commit('site/NEXT_IS_SHOW_CUSTOMER_SERVICE', true)
      })
      const methods = {
        [CustomerServiceTypeEnum.AIHelp]: this.showAiHelp
      }
      methods[this.type]?.()
    }
  }
}
</script>

<style lang="less">
.AIHelpSupportBox {
  width: 100vw;
  height: var(--app-height-px);
  position: fixed;
}

.AIHelpSupportClose {
  position: absolute;
  right: 10px;
  top: 6px;
  width: 30px;
  height: 30px;
  color: #fff;
  background: #f9c633;
  border-radius: 25px;
  cursor: pointer;
}

.AIHelpSupportClose:before {
  position: absolute;
  content: "";
  width: 20px;
  height: 2px;
  background: #fff;
  transform: rotate(45deg);
  top: 14px;
  left: 6px;
}

.AIHelpSupportClose:after {
  content: "";
  position: absolute;
  width: 20px;
  height: 2px;
  background: #fff;
  transform: rotate(-45deg);
  top: 14px;
  left: 6px;
}

.support-setting {
  position: fixed;
  z-index: 1000;
  cursor: pointer;
  .el-badge__content.is-fixed {
    position: absolute;
    top: 8px;
    right: 15px;
  }
  &.bottom-left {
    bottom: 40px;
    left: 40px;
  }
  &.bottom-right {
    bottom: 40px;
    right: 40px;
  }
  &.editing.bottom-right {
    right: 280px;
  }
  &.editing.bottom-left {
    left: 350px;
  }
  &.is-mobile.bottom-right {
    bottom: 20px;
    right: 20px;
  }
}
</style>
